query GetDid($id: ID!) {
  did(id: $id) {
    id
    insertedAt
    updatedAt
    activeAt
    expireAt

    type
    number
    isByon

    tzOffsetSecs
    olsonTz

    smsStatus

    smsEnabled
    smsInboundBlocked
    smsOutboundBlocked

    mmsStatus

    mmsEnabled
    mmsInboundBlocked
    mmsOutboundBlocked

    switch {
      id
      name
      insertedAt
      updatedAt
      notes
      smsEnabled
      smsIdentity
      smsSecret
      smsEndpoints
      smsOptions {
        expiredToMailbox
        customHeaders {
          name
          value
        }
        customParams {
          name
          value
        }
      }
      smsProtocol

      mmsEnabled
      mmsIdentity
      mmsSecret
      mmsEndpoints
      mmsOptions {
        expiredToMailbox
        customHeaders {
          name
          value
        }
        customParams {
          name
          value
        }
      }
      mmsProtocol

      account {
        id
        name
      }
    }

    account {
      id
      name
    }

    autoResponse {
      id
      insertedAt
      updatedAt
      name
      notes
      keywords {
        id
        message
        keyword
        isWildcard
        intercept
      }
    }
  }
}
